import { inject, Injectable } from '@angular/core'
import Keycloak from 'keycloak-js'
import { MenuItem } from 'primeng/api'
import { UI_MENU, USER_MENU } from '../constants/menu.constant'
import { ConfigInterface } from '../interfaces/config.interface'
import { ApiUrlService } from './api-url.service'
import { MenuService } from './menu.service'
import { environment } from 'src/app/app.config'

@Injectable({
    providedIn: 'root'
})
export class InitService {
    private apiUrlService = inject(ApiUrlService)
    private menuService = inject(MenuService)
    keycloak = inject(Keycloak)

    initApiUrl(): this {
        this.apiUrlService.setApiUrl(environment.HOST || '')
        return this
    }

    initMenu(): this {
        const menu = UI_MENU as MenuItem[]
        this.menuService.set(menu)

        const userMenu = USER_MENU as MenuItem[]
        this.menuService.setUserMenu(userMenu)

        return this
    }

    getConfig(): ConfigInterface {
        return environment
    }
}
